module.exports = __webpack_public_path__ + "img/gotfertomi-coussins-cafe-2.e68e4ebb.jpg";